// initial values of chatbot modal
let originalFontSize = 12;
let chatBotModalCurrentHeight = 484;
let chatBotModalCurrentWidth = 350;
const SESSION_STORAGE_CHAT_HISTORY_KEY = "olive-chatbot-conversation";
const THIRTY_MINUTES_IN_MILLISECONDS = 1800000;

// const isMobile = window.innerHTML < 743;

const handleInputEvents = () => {
  const chatSend = document.querySelector('.chat-btn-send');
  const chatInput = document.querySelector('.chat-input');
  const inputClose = document.querySelector('.chat-input-close');

  inputClose.style.display = 'none';

  chatSend.addEventListener('click', handleSendMessage);

  chatInput.addEventListener('keyup', (e) =>
    handleInputKeyup(e, chatSend, inputClose)
  );

  chatInput.addEventListener('keypress', (e) =>
    handleInputKeypress(e, inputClose)
  );

  inputClose.addEventListener('click', () =>
    handleInputClose(chatInput, chatSend, inputClose)
  );
};

const handleChatHistory = (clientMsg, botMsgs) => {
  const chatHistory = sessionStorage.getItem(SESSION_STORAGE_CHAT_HISTORY_KEY);
  const storeMessages = chatHistory
    ? JSON.parse(chatHistory).value
    : [];

  storeMessages.push({
    clientMsg: clientMsg,
    botMsgs: JSON.parse(botMsgs),
  });

  sessionStorage.setItem(
    SESSION_STORAGE_CHAT_HISTORY_KEY,
    JSON.stringify({
      expiry: new Date().getTime() + THIRTY_MINUTES_IN_MILLISECONDS,
      value: [...storeMessages],
    })
  );
};

const setModalSize = () => {
  const chatBotModal = document.querySelector('.chat-bot-modal');
  if (chatBotModal) {
    if (window.matchMedia('(min-width: 744px)').matches) {
      chatBotModal.style.height = chatBotModalCurrentHeight + 'px';
      chatBotModal.style.width = chatBotModalCurrentWidth + 'px';
    }
  }
};

const createDisclaimerModal = () => {
  const disclaimerModalHTML = `
    <div class="disclaimer-modal">
      <div class="disclaimer-content d-flex flex-column h-100 p-3">
        <button class="btn btn-icon disclaimer-back-button mb-2" aria-label="back"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#3C548E" /></svg></button>
        <p class="disclaimer-content-text mt-2">Our Olive Al chatbot tool (Olive) is intended to assist you with your employer group benefits.<br></br>PlanSource does not guarantee the accuracy of Olive's information; please review and verify information before acting upon it. We are not responsible for decisions or recommendations made based upon its use.<br></br>Please avoid sharing personal or confidential information with Olive; any information provided to Olive will be governed by the PlanSource <a href="https://plansource.com/privacy-policy/" target="_blank">Privacy Policy</a>.<br></br>Olive is meant to enhance your enrollment experience, not replace professional advice. Please consult a benefits advisor or HR representative, as needed.</p>
      </div>
    </div>
  `;
  const chatContainer = document.querySelector('.chat-container');
  if (!chatContainer.querySelector('.disclaimer-modal')) {
    chatContainer.innerHTML += disclaimerModalHTML;
  }
};

const handleDisclaimerModal = () => {
  const disclaimerBtn = document.querySelector('.disclaimer-btn');
  disclaimerBtn.addEventListener('click', () => {
    const disclaimerModal = document.querySelector('.disclaimer-modal');
    disclaimerModal.style.display = 'block';
  });
  const closeDisclaimer = document.querySelector('.disclaimer-back-button');
  closeDisclaimer.addEventListener('click', () => {
    const disclaimerModal = document.querySelector('.disclaimer-modal');
    disclaimerModal.style.display = 'none';
  });
};

export const buildChatBotModal = (initialText, enrollment = false) => {
  const customHeader =
    '<div class="custom-header"><div class="header-content"><div class="header-icon"><svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53" fill="none"><circle cx="26.087" cy="26.087" r="26.087" fill="white"/><rect x="11" y="16" width="30" height="16.875" rx="8.4375" fill="#212935"/><rect x="15" y="19" width="22.5" height="11" rx="5.5" fill="white"/><path d="M30.9065 37.187L37.5784 30.7339L30.9065 31.2808V37.187Z" fill="#212935"/><circle cx="20" cy="24.5" r="1.5" fill="#212935"/><circle cx="32.5" cy="24.5" r="1.5" fill="#212935"/></svg></div><div class="content"><h3 class="title title-bold">Olive</h3><div>Your virtual assistant</div></div></div><button class="close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.6957 1.70644L14.1631 0.173828L8.08697 6.24992L2.01088 0.173828L0.478271 1.70644L6.55436 7.78252L0.478271 13.8586L2.01088 15.3912L8.08697 9.31513L14.1631 15.3912L15.6957 13.8586L9.61958 7.78252L15.6957 1.70644Z" fill="white"/></svg><span class="sr-only">Close</span></button></div>';
  const modal =
    '<div class="message-container"><div class="chat-container"><div class="chat-inner-container d-flex justify-content-center"><div class="chat-message-container"></div><div class="chat-input-container"><textarea class="chat-input" placeholder="Type here..." aria-label="Ask Olive"></textarea><div class="chat-input-close"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#3C548E"/></svg></div><div class="chat-btn-send-loader d-none" aria-label="submit"><div class="chatbot-loader-container d-flex justify-content-center w-100"><svg id="dots" width="50px" height="21px" viewBox="0 0 132 58" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="none"><g id="chatbot-loader" fill="#3C548E"><circle id="chatbot-loader-dot1" cx="25" cy="30" r="13"></circle><circle id="chatbot-loader-dot2" cx="65" cy="30" r="13"></circle><circle id="chatbot-loader-dot3" cx="105" cy="30" r="13"></circle></g></g></svg></div></div><button type="button" class="chat-btn-send d-none disabled"><svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20.5714L24 10.2857L0.0114286 0L0 8L17.1429 10.2857L0 12.5714L0.0114286 20.5714Z" fill="#3C548E" /></svg></button></div><div class="disclaimer-text"><div>Use of Olive implies acceptance of the <a class="disclaimer-btn" href="#">Disclaimer.</a></div></div></div></div></div>';
  let chatBot = document.querySelector('.chat-bot');

  const bodyElement = document.querySelector('body');
  if (chatBot === null) {
    const chatBotElement = document.createElement('div');
    chatBotElement.setAttribute(
      'class',
      enrollment
        ? 'chat-bot chat-enrollment-location'
        : 'chat-bot chat-default-location'
    );

    if (bodyElement) {
      bodyElement.append(chatBotElement);
    }
  } else {
    return;
  }
  chatBot = document.querySelector('.chat-bot');
  chatBot.innerHTML += '<div class="chat-bot-modal"></div>';
  document.querySelector('.chat-bot-modal').innerHTML += customHeader;
  document.querySelector('.chat-bot-modal').innerHTML += modal;

  // Set focus on the close button
  const closeButton = chatBot.querySelector('.custom-header .close');
  if (closeButton) {
    closeButton.setAttribute('id', 'close-olive-chatbot');
    closeButton.focus();
  }

  const chatBotModalClose = chatBot.querySelector('.custom-header .close');
  chatBotModalClose.addEventListener('click', (e) =>
    handleChatBotModalClose(e)
  );
  handleResizeModal();
  handleInputEvents();
  createDisclaimerModal();
  handleDisclaimerModal();

  if (initialText) {
    document.querySelector('.chat-input').value = initialText;
    handleSendMessage();
  } else if (
    sessionStorage.getItem(SESSION_STORAGE_CHAT_HISTORY_KEY) &&
    validExpiry(sessionStorage.getItem(SESSION_STORAGE_CHAT_HISTORY_KEY))
  ) {
    createBotMessage('hi', false);
  } else {
    createBotMessage();
  }

  setModalSize();
};

const handleResizeModal = () => {
  const modalElement = document.querySelector('.chat-bot-modal');
  const resizeHandle = document.createElement('button');

  const resizeHandleIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g transform="matrix(-0.5699999999999996,-6.980486755139909e-17,6.980486755139909e-17,-0.5699999999999996,12.764999251365653,12.764999251365657)"><g fill="#000"><path d="M22.414 8 8 22.414 6.586 21 21 6.586zM22.414 15 15 22.414 13.586 21 21 13.586z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></g></svg>';

  resizeHandle.setAttribute('id', 'resize-handler');
  resizeHandle.style.width = '30px';
  resizeHandle.style.height = '30px';
  resizeHandle.style.position = 'absolute';
  resizeHandle.style.top = '0';
  resizeHandle.style.left = '0';
  resizeHandle.style.cursor = 'nwse-resize';
  resizeHandle.style.backgroundColor = 'transparent';
  resizeHandle.innerHTML += resizeHandleIcon;
  modalElement.appendChild(resizeHandle);

  const minimumResizableHeight = 484;
  const minimumResizableWidth = 350;
  const maximumResizableHeight = window.innerHeight * 0.85;
  const maximumResizableWidth = window.innerWidth * 0.55;

  // variable declarations to get the modal original position
  let originalWidth = 0;
  let originalHeight = 0;
  let originalX = 0;
  let originalMouseX = 0;
  let originalMouseY = 0;

  resizeHandle.addEventListener('mousedown', function (e) {
    e.preventDefault();
    originalWidth = parseFloat(
      getComputedStyle(modalElement, null)
        .getPropertyValue('width')
        .replace('px', '')
    );
    originalHeight = parseFloat(
      getComputedStyle(modalElement, null)
        .getPropertyValue('height')
        .replace('px', '')
    );
    originalX = modalElement.getBoundingClientRect().left;
    originalMouseX = e.pageX;
    originalMouseY = e.pageY;
    window.addEventListener('mousemove', resize);
    window.addEventListener('mouseup', stopResize);
  });
  // Resizing the height of the message container
  function adjustMessageHeight() {
    const modalElement = document.querySelector('.chat-bot-modal');
    if (modalElement) {
      const modalCurrentHeight = modalElement.offsetHeight;
      const modalCurrentWidth = modalElement.offsetWidth;
      if (modalCurrentHeight > 0 && modalCurrentWidth > 0) {
        chatBotModalCurrentHeight = modalCurrentHeight;
        chatBotModalCurrentWidth = modalCurrentWidth;
      }

      const messageContainer = document.querySelector('.message-container');
      const chatInnerContainer = document.querySelector(
        '.chat-inner-container'
      );
      const chatMessageContainer = document.querySelector(
        '.chat-message-container'
      );
      const newChatMessageMaxHeigth = modalCurrentHeight - 179 + 'px';
      const newChatInnerMessageContainerHeight = modalCurrentHeight - 84 + 'px';
      if (messageContainer) {
        messageContainer.style.height = newChatInnerMessageContainerHeight;
        chatInnerContainer.style.height = newChatInnerMessageContainerHeight;
        chatMessageContainer.style.maxHeight = newChatMessageMaxHeigth;
      }
    }
  }
  function adjustModalFontSize() {
    if (modalElement) {
      const modalCurrentWidth = modalElement.offsetWidth;
      originalFontSize = Math.max(12, modalCurrentWidth / 50);
      const newFontSize = originalFontSize + 'px';
      const botMessages = document.querySelectorAll('.chat-bot-message');
      const userMessages = document.querySelectorAll('.user-chat-message');
      const emojis = document.querySelectorAll('.emoji');
      const optionsContainer = document.querySelectorAll('.options-container');
      const faqContainer = document.querySelectorAll('.faq-content');
      const documentFileContent = document.querySelectorAll(
        '.document-file-content'
      );
      const documentFileAction = document.querySelectorAll(
        '.document-file-action'
      );
      if (botMessages) {
        botMessages.forEach(
          (content) => (content.style.fontSize = newFontSize)
        );
      }
      if (userMessages) {
        userMessages.forEach(
          (content) => (content.style.fontSize = newFontSize)
        );
      }
      if (emojis) {
        emojis.forEach(
          (emoji) => (emoji.style.fontSize = originalFontSize + 2 + 'px')
        );
      }
      if (optionsContainer) {
        for (let i = 0; i < optionsContainer.length; i++) {
          optionsContainer[i].childNodes.forEach(
            (content) => (content.style.fontSize = newFontSize)
          );
        }
      }
      if (faqContainer) {
        for (let i = 0; i < faqContainer.length; i++) {
          faqContainer[i].childNodes.forEach((content) => {
            content.style.fontSize = newFontSize;
          });
        }
      }
      if (documentFileAction) {
        documentFileAction.forEach(
          (content) => (content.style.fontSize = newFontSize)
        );
      }

      if (documentFileContent) {
        for (let i = 0; i < documentFileContent.length; i++) {
          documentFileContent[i].childNodes.forEach((content) => {
            if (content.nodeType === 1) {
              content.style.fontSize = newFontSize;
            }
          });
        }
      }
    }
  }
  function adjustModalContent() {
    adjustMessageHeight();
    adjustModalFontSize();
  }
  function resize(e) {
    const width = originalWidth - (e.pageX - originalMouseX);
    const height = originalHeight - (e.pageY - originalMouseY);

    if (width >= minimumResizableWidth && width <= maximumResizableWidth) {
      modalElement.style.width = width + 'px';
      modalElement.style.left = originalX + (e.pageX - originalMouseX) + 'px';
    }
    if (height >= minimumResizableHeight && height <= maximumResizableHeight) {
      modalElement.style.height = height + 'px';
      modalElement.style.top =
        originalMouseY + (e.pageY - originalMouseY) + 'px';
    }
    adjustModalContent();
  }

  function stopResize() {
    window.removeEventListener('mousemove', resize);
    window.removeEventListener('moveup', stopResize);
  }

  window.addEventListener('resize', function () {
    const maximumHeight = window.innerHeight * 0.85;
    const maximumWidth = window.innerWidth * 0.55;
    const resizeHandler = document.getElementById('resize-handler');
    const messageContainer = document.querySelector('.message-container');

    let modalCurrentHeight = 0;
    if (modalElement) {
      modalCurrentHeight = modalElement.offsetHeight;
    }
    const newChatMessageMaxHeigth = modalCurrentHeight - 179 + 'px';
    const chatMessageContainer = document.querySelector(
      '.chat-message-container'
    );

    const currentWidth = parseFloat(
      getComputedStyle(modalElement, null)
        .getPropertyValue('width')
        .replace('px', '')
    );
    const currentHeight = parseFloat(
      getComputedStyle(modalElement, null)
        .getPropertyValue('height')
        .replace('px', '')
    );

    if (window.matchMedia('(min-width: 768px)').matches) {
      if (resizeHandler) {
        resizeHandler.style.display = 'block';
      }
      if (currentWidth > maximumWidth) {
        modalElement.style.width = maximumWidth + 'px';
      }
      if (currentHeight > maximumHeight) {
        modalElement.style.height = maximumHeight + 'px';
      }
      if (messageContainer) {
        chatMessageContainer.style.maxHeight = newChatMessageMaxHeigth;
      }
      adjustModalContent();
    } else {
      if (resizeHandler) {
        resizeHandler.style.display = 'none';
        modalElement.style.width = '100vw';
        modalElement.style.left = '0';
        modalElement.style.height = 'auto';
        modalElement.style.top = '0';
      }
      if (messageContainer) {
        messageContainer.style.height = '100svh';
        chatMessageContainer.style.maxHeight = modalCurrentHeight - 179 + 'px';
      }
    }
  });
};

const handleInputKeyup = (e, chatSend, inputClose) => {
  if (e.keyCode === 13) {
    e.preventDefault();
  }
  if (
    document.querySelectorAll(
      '.chat-message-container .chatbot-loader-container'
    ).length > 0
  ) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
    inputClose.style.display = 'block';
    return;
  }

  if (e.keyCode !== 13) {
    if (e.target.value === '') {
      inputClose.style.display = 'none';
      chatSend.classList.add('disabled');
    } else {
      inputClose.style.display = 'block';
      chatSend.classList.remove('disabled');
    }
    return;
  }
  handleSendMessage();
};

const handleInputKeypress = (e, inputClose) => {
  if (e.keyCode === 13) {
    e.preventDefault();
  }
  if (
    document.querySelectorAll(
      '.chat-message-container .chatbot-loader-container'
    ).length > 0
  ) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
    inputClose.style.display = 'block';
  }
};

const handleInputClose = (chatInput, chatSend, inputClose) => {
  chatInput.value = '';
  inputClose.style.display = 'none';
  chatSend.classList.add('disabled');
};

const handleChatBotModalClose = (e) => {
  const bodyElement = document.querySelector('body');
  const overlay = bodyElement.querySelector('.chatbot-overlay');
  if (overlay) {
    overlay.remove();
  }
  e.target.parentNode.closest('.chat-bot').remove();
  bodyElement.classList.remove('chatbot-open');

};

const handleSendMessage = () => {
  const clientMsg = document.querySelector('.chat-input').value;
  if (clientMsg.trim() === '') {
    return;
  }
  createClientMessage(clientMsg, true);
  document.querySelector('.chat-input').value = '';
  document.querySelector('.chat-btn-send').classList.add('disabled', 'd-none');
  document.querySelector('.chat-input-close').style.display = 'none';
  document.querySelector('.chat-input').focus();
};

const checkDocumentReader = (data) => {
  return data.some((item) => item.text === 'document_reader_UI');
};

const validExpiry = (chatHistory) => {
  const expiry = JSON.parse(chatHistory).expiry || 0;
  const now = new Date().getTime();
  if (now > expiry) {
    deleteChatHistory();
    return false;
  }
  return true;
};

// function to restore chatbot messages
const restoreChatBotMessages = (feedbackResponse) => {
  const chatHistory = sessionStorage.getItem(SESSION_STORAGE_CHAT_HISTORY_KEY);
  if (chatHistory) {
    const chatbotMsgs = JSON.parse(chatHistory).value;

    if (chatbotMsgs[0] && chatbotMsgs[0].clientMsg !== 'hi') {
      chatbotMsgs[0] && createClientMessage(chatbotMsgs[0].clientMsg, false);
    }

    for (let i = 0; i < chatbotMsgs.length; i++) {
      showLoader();
      buildBotMsg(
        chatbotMsgs[i].botMsgs,
        chatbotMsgs[i] && chatbotMsgs[i].clientMsg,
        feedbackResponse,
        false
      );

      const isDocumentReader = checkDocumentReader(chatbotMsgs[i].botMsgs);
      const options = chatbotMsgs[i].botMsgs.map((items) => items.buttons);
      !isDocumentReader &&
        options &&
        options.forEach((option) => {
          if (option && option.length > 0) {
            buildOptions(option, true);
          }
        });

      chatbotMsgs[i + 1] &&
        createClientMessage(chatbotMsgs[i + 1].clientMsg, false);
    }

    scrollIntoView();
    document.querySelector('.chat-input').removeAttribute('readonly');
  }
};

const createBotMessage = (clientMsg, storeChatMessages = true) => {
  clientMsg = clientMsg || 'hi';
  if (document.getElementById('chatbot_api_url') === null) {
    return;
  }
  const chatbotApiUrl = document.getElementById('chatbot_api_url').value;
  const chatbotIdentity = document.getElementById('chatbot_identity').value;
  const userSessionId = document.getElementById('user_session_id').value;
  const organizationId = document.getElementById('org_id').value;
  const benAdminUrl = document.getElementById('benadmin_api_url').value;
  const domainLocation = window.location;
  const orgCode = domainLocation.pathname.split('/')[1];
  const feedbackResponses = [
    'received positive feedback',
    'received negative feedback',
  ];
  const feedbackResponse = feedbackResponses.includes(clientMsg);
  const emptyResponseText =
    "I'm sorry, I'm having trouble understanding your request. Can you please provide me with more information or rephrase your question so that I can better assist you?";

  const data = {
    sender: chatbotIdentity, // Random id if its not a logged in user
    message: clientMsg,
    metadata: {
      apiUrl: benAdminUrl,
      appUrl: `${domainLocation.origin}/${orgCode}`,
      session_id: userSessionId === 'null' ? null : userSessionId,
      org_id: organizationId === 'null' ? null : organizationId,
    },
  };

  let options = {};
  feedbackResponse &&
    document.querySelectorAll('.options-container').forEach((elem) => {
      elem.remove();
    });

  if (!storeChatMessages) {
    restoreChatBotMessages(feedbackResponse);
    return;
  }
  showLoader();

  fetch(chatbotApiUrl, {
    method: 'POST',
    body: JSON.stringify(data),
    dataType: 'json',
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.length === 0) {
        buildBotMsg(
          [
            {
              text: emptyResponseText,
            },
          ],
          true
        );
        scrollIntoView();
        return;
      }
      const isDocumentReader = checkDocumentReader(data);
      options = data.map((items) => items.buttons);
      buildBotMsg(data, clientMsg, feedbackResponse, true);
      !isDocumentReader &&
        options &&
        options.forEach((option) => {
          if (option && option.length > 0) {
            buildOptions(option, true);
          }
        });
      scrollIntoView();
      document.querySelector('.chat-input').removeAttribute('readonly');
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const showLoader = () => {
  const botMsgField = `<div class="chat-bot-message-container"><div class="bot-avatar-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="12" fill="#212935"/><rect x="2.85709" y="6.28711" width="18.2857" height="10.2857" rx="5.14286" fill="white"/><rect x="5.14282" y="8.00146" width="13.7143" height="6.85714" rx="3.42857" fill="#212935"/><path d="M14.9905 19.2014L19.0571 15.2681L14.9905 15.6014V19.2014Z" fill="white"/><circle cx="8.13337" cy="11.3347" r="0.8" fill="white"/><circle cx="15.8667" cy="11.3347" r="0.8" fill="white"/></svg></div><div class="chat-bot-message" style="font-size: ${originalFontSize}px"><div class="chatbot-loader-container"><svg id="dots" width="50px" height="21px" viewBox="0 0 132 58" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="none"><g id="chatbot-loader" fill="#fff"><circle id="chatbot-loader-dot1" cx="25" cy="30" r="13"></circle><circle id="chatbot-loader-dot2" cx="65" cy="30" r="13"></circle><circle id="chatbot-loader-dot3" cx="105" cy="30" r="13"></circle></g></g></svg></div></div></div>`;

  document.querySelector('.chat-message-container').innerHTML += botMsgField;

  serverTimeout = setTimeout(() => {
    if (
      !document.querySelector('.server-delay-msg') &&
      document.querySelector('.chat-message-container') !== null
    ) {
      const serverErrorElement = document.createElement('div');
      serverErrorElement.setAttribute('class', 'server-delay-msg text-center');
      serverErrorElement.innerHTML =
        'The server is taking longer to respond than usual. Please wait...';

      document
        .querySelector('.chat-message-container')
        .insertBefore(
          serverErrorElement,
          document.querySelector('.chat-message-container').lastChild
        );
      scrollIntoView();
    }
  }, 10000);

  document.querySelector('.chat-btn-send-loader').classList.remove('d-none');
  document.querySelector('.chat-btn-send').classList.add('d-none');
};

const createFaqModal = (clientMsg, botMsgs) => {
  const faqModal =
    `<div class="faq-modal"><div class="back-button"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#3C548E" /></svg></div><div class="faq-content"><div class="faq-header" style="font-size: ${originalFontSize}px">` +
    clientMsg +
    `</div><div class="faq-response" style="font-size: ${originalFontSize}px" >` +
    botMsgs +
    `</div><div class="view-less" style="font-size: ${originalFontSize}px" >View Less</div></div></div>`;

  document.querySelector('.chat-container').innerHTML += faqModal;
};

const handleFaqModals = () => {
  const modals = document.querySelectorAll('.chat-container .faq-modal');
  const viewMoreButtons = document.querySelectorAll('.chat-bot .view-more');
  const backBtns = document.querySelectorAll(
    '.chat-container .faq-modal .back-button'
  );
  const viewLessBtns = document.querySelectorAll(
    '.chat-container .faq-modal .view-less'
  );

  for (let i = 0; i < viewMoreButtons.length; i++) {
    viewMoreButtons[i].addEventListener('click', function () {
      modals[i].style.display = 'block';
    });

    backBtns[i].addEventListener('click', function () {
      modals[i].style.display = 'none';
    });

    viewLessBtns[i].addEventListener('click', function () {
      modals[i].style.display = 'none';
    });
  }
};

const buildBotMsg = (data, clientMsg, feedbackResponse, storeChatMessages) => {
  if (!storeChatMessages) {
    if (clientMsg === 'received positive feedback') {
      const element = document.querySelector('.helpful');
      element.classList.remove('helpful');
      element.classList.add('selected-feedback');
      element.innerHTML =
        '<div class="liked-icon"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.09091H1.81818V3.63636H0V9.09091ZM10 4.09091C10 3.59091 9.59091 3.18182 9.09091 3.18182H6.22273L6.65455 1.10455L6.66818 0.959091C6.66818 0.772727 6.59091 0.6 6.46818 0.477273L5.98636 0L2.99545 2.99545C2.82727 3.15909 2.72727 3.38636 2.72727 3.63636V8.18182C2.72727 8.68182 3.13636 9.09091 3.63636 9.09091H7.72727C8.10455 9.09091 8.42727 8.86364 8.56364 8.53636L9.93636 5.33182C9.97727 5.22727 10 5.11818 10 5V4.09091Z" fill="white"/></svg></div>';
    } else if (clientMsg === 'received negative feedback') {
      const element = document.querySelector('.helpful');
      element.classList.remove('helpful');
      element.classList.add('selected-feedback');
      element.innerHTML =
        '<div class="disliked-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="9" transform="rotate(-90 9 9)" fill="#3C548E"/><path d="M14 3.99991H12.1818L12.1818 9.45446H14L14 3.99991ZM4 8.99991C4 9.49991 4.40909 9.909 4.90909 9.909L7.77727 9.909L7.34545 11.9863L7.33182 12.1317C7.33182 12.3181 7.40909 12.4908 7.53182 12.6135L8.01364 13.0908L11.0045 10.0954C11.1727 9.93173 11.2727 9.70446 11.2727 9.45446V4.909C11.2727 4.409 10.8636 3.99991 10.3636 3.99991L6.27273 3.99991C5.89545 3.99991 5.57273 4.22718 5.43636 4.55446L4.06364 7.759C4.02273 7.86355 4 7.97264 4 8.09082V8.99991Z" fill="white"/></svg></div>';
    }
  }

  const lastBotMessageIndex =
    document.querySelectorAll('.chat-bot-message-container').length - 1;

  data.forEach(function (arrItem) {
    const index = data.indexOf(arrItem);
    if (arrItem.text === 'document_reader_UI') {
      storeChatMessages && handleDocumentReaderUI(data);
      return;
    }
    if (arrItem.text === 'add feedback to last answer') {
      handleFeedback(lastBotMessageIndex);
      return;
    }
    const botMsgs = arrItem.text && arrItem.text.replaceAll('\n', '<br>');

    const handleMessage = (msg) => {
      return msg.replace(
        'Hello there!',
        `Hello there! <span class="emoji" style="font-size:${originalFontSize + 4}px" > 👋</span>`
      );
    };

    if (
      document
        .querySelectorAll('.chat-bot-message-container')
      [lastBotMessageIndex].querySelector('.chat-bot-message')
        .innerHTML.includes('chatbot-loader-container')
    ) {
      document
        .querySelectorAll('.chat-bot-message-container')
      [lastBotMessageIndex].querySelector('.chat-bot-message')
        .remove();
      document.querySelector('.chat-btn-send-loader').classList.add('d-none');
      document.querySelector('.chat-btn-send').classList.remove('d-none');
      clearTimeout(serverTimeout);
      document.querySelector('.server-delay-msg') &&
        document.querySelector('.server-delay-msg').remove();
    }

    document.querySelectorAll('.chat-bot-message-container')[
      lastBotMessageIndex
    ].innerHTML +=
      `<div class="chat-bot-message-inner-container" style="font-size: ${originalFontSize}px"></div>`;

    document
      .querySelectorAll('.chat-bot-message-container')
    [
      lastBotMessageIndex
    ].querySelector('.chat-bot-message-inner-container').innerHTML +=
      `<div class="chat-bot-message" style="font-size:${originalFontSize}px">` +
      (botMsgs && botMsgs.split(' ').length > 50
        ? botMsgs.split(' ', 50).join(' ') +
        '...' +
        '<div class="view-more">View More</div>'
        : handleMessage(botMsgs)) +
      '</div>' +
      '<div class="chat-message-time">' +
      handleMessageTime() +
      '</div>';
    botMsgs &&
      botMsgs.split(' ').length > 50 &&
      createFaqModal(clientMsg, botMsgs);
    if (feedbackResponse && index === 0) {
      document.querySelectorAll('.options-container').forEach((elem) => {
        elem.remove();
      });
      document
        .querySelectorAll('.chat-bot-message-container')
      [lastBotMessageIndex].querySelector('.bot-avatar-icon')
        .remove();
      document
        .querySelectorAll('.chat-bot-message-container')
      [lastBotMessageIndex].querySelector('.chat-bot-message-inner-container')
        .classList.add('feedback-message');
    }
  });

  // store chatbot messages in sessionStorage
  if (storeChatMessages) {
    handleChatHistory(clientMsg, JSON.stringify(data));
  }
  handleFaqModals();
  handleInputEvents();
  handleDisclaimerModal();
};

const handleFeedback = (lastBotMessageIndex) => {
  document
    .querySelectorAll('.chat-bot-message-container')
  [
    lastBotMessageIndex
  ].querySelector('.chat-bot-message-inner-container').innerHTML +=
    '<div class="helpful">Was this helpful ?<div class="like-dislike"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="like"><path d="M6.54545 16.3636H13.9091C14.5882 16.3636 15.1691 15.9545 15.4145 15.3655L17.8855 9.59727C17.9591 9.40909 18 9.21273 18 9V7.36364C18 6.46364 17.2636 5.72727 16.3636 5.72727H11.2009L11.9782 1.98818L12.0027 1.72636C12.0027 1.39091 11.8636 1.08 11.6427 0.859091L10.7755 0L5.38364 5.39182C5.08909 5.68636 4.90909 6.09545 4.90909 6.54545V14.7273C4.90909 15.6273 5.64545 16.3636 6.54545 16.3636ZM6.54545 6.54545L10.0964 2.99455L9 7.36364H16.3636V9L13.9091 14.7273H6.54545V6.54545ZM0 6.54545H3.27273V16.3636H0V6.54545Z" fill="#3C548E"/></svg><div class="divider">|</div><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="dislike"><path d="M11.4545 0H4.09091C3.41182 0 2.83091 0.409091 2.58545 0.998182L0.114545 6.76636C0.0409091 6.95455 0 7.15091 0 7.36364V9C0 9.9 0.736364 10.6364 1.63636 10.6364H6.79909L6.02182 14.3755L5.99727 14.6373C5.99727 14.9727 6.13636 15.2836 6.35727 15.5045L7.22455 16.3636L12.6164 10.9718C12.9109 10.6773 13.0909 10.2682 13.0909 9.81818V1.63636C13.0909 0.736364 12.3545 0 11.4545 0ZM11.4545 9.81818L7.90364 13.3691L9 9H1.63636V7.36364L4.09091 1.63636H11.4545V9.81818ZM14.7273 0H18V9.81818H14.7273V0Z" fill="#3C548E"/></svg></div></div>';

  const helpfulButtons = document.querySelectorAll('.helpful');

  for (const element of helpfulButtons) {
    element
      .querySelector('.like-dislike .like')
      .addEventListener('click', function () {
        element.classList.remove('helpful');
        element.classList.add('selected-feedback');
        element.innerHTML =
          '<div class="liked-icon"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.09091H1.81818V3.63636H0V9.09091ZM10 4.09091C10 3.59091 9.59091 3.18182 9.09091 3.18182H6.22273L6.65455 1.10455L6.66818 0.959091C6.66818 0.772727 6.59091 0.6 6.46818 0.477273L5.98636 0L2.99545 2.99545C2.82727 3.15909 2.72727 3.38636 2.72727 3.63636V8.18182C2.72727 8.68182 3.13636 9.09091 3.63636 9.09091H7.72727C8.10455 9.09091 8.42727 8.86364 8.56364 8.53636L9.93636 5.33182C9.97727 5.22727 10 5.11818 10 5V4.09091Z" fill="white"/></svg></div>';
        createBotMessage('received positive feedback', true);
      });

    element
      .querySelector('.like-dislike .dislike')
      .addEventListener('click', function () {
        element.classList.remove('helpful');
        element.classList.add('selected-feedback');
        element.innerHTML =
          '<div class="disliked-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="9" transform="rotate(-90 9 9)" fill="#3C548E"/><path d="M14 3.99991H12.1818L12.1818 9.45446H14L14 3.99991ZM4 8.99991C4 9.49991 4.40909 9.909 4.90909 9.909L7.77727 9.909L7.34545 11.9863L7.33182 12.1317C7.33182 12.3181 7.40909 12.4908 7.53182 12.6135L8.01364 13.0908L11.0045 10.0954C11.1727 9.93173 11.2727 9.70446 11.2727 9.45446V4.909C11.2727 4.409 10.8636 3.99991 10.3636 3.99991L6.27273 3.99991C5.89545 3.99991 5.57273 4.22718 5.43636 4.55446L4.06364 7.759C4.02273 7.86355 4 7.97264 4 8.09082V8.99991Z" fill="white"/></svg></div>';
        createBotMessage('received negative feedback', true);
      });
  }

  handleInputEvents();
};

const buildOptions = (opts, storeChatMessages) => {
  const lastBotMessageIndex =
    document.querySelectorAll('.chat-bot-message-container').length - 1;

  document
    .querySelectorAll('.chat-bot-message-container')
  [
    lastBotMessageIndex
  ].insertAdjacentHTML('afterend', '<div class="options-container"></div>');

  opts.forEach((item) => {
    document.querySelector('.options-container').innerHTML +=
      `<button class="option-button" style="font-size:${originalFontSize}px">${item.title}</button>`;
  });

  document.querySelectorAll('.option-button').forEach((elem) =>
    elem.addEventListener('click', function (e) {
      document.querySelector('.chat-btn-send-loader').classList.remove('d-none');
      document.querySelector('.chat-btn-send').classList.add('d-none');
      document.querySelector('.chat-input').focus();
      removeOptions(e.target);
      createClientMessage(e.target.textContent, storeChatMessages);
    })
  );
  document.querySelectorAll('.option-button').length > 4 &&
    document.querySelector('.options-container').classList.add('stack-view');
};

const removeOptions = (currentTarget) => {
  currentTarget.closest('.options-container').remove();
};

const createClientMessage = (userMessage, storeChatMessages) => {
  if (
    (!storeChatMessages && userMessage === 'received positive feedback') ||
    userMessage === 'received negative feedback' ||
    userMessage === 'back_to_chat'
  ) {
    return;
  }

  const clientMsgField =
    `<div class="user-chat-message-container"><div class="user-chat-message" style="font-size:${originalFontSize}px" ">` +
    userMessage +
    '</div><div class="chat-message-time user-chat-message-time">' +
    handleMessageTime() +
    '</div></div>';
  document.querySelector('.chat-message-container').innerHTML += clientMsgField;

  document.querySelectorAll('.options-container').forEach((elem) => {
    elem.remove();
  });

  document.querySelectorAll('.helpful').forEach((feedback) => {
    feedback.remove();
  });

  // create bot message if messages are not loading from sessionStorage
  if (Boolean(storeChatMessages)) {
    createBotMessage(userMessage, storeChatMessages);
    scrollIntoView();
  }
};

const scrollIntoView = () => {
  const messageContainer = document.querySelector('.chat-message-container');
  if (messageContainer !== null) {
    const scrollTill = messageContainer.scrollHeight;
    messageContainer.scrollTo(0, scrollTill);
  }
};

const handleMessageTime = () => {
  const date = new Date();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  const strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};

async function fetchAndCacheSummary(requestData) {
  const storageKey = `summary_${JSON.stringify(requestData)}`;
  const cachedResponse = localStorage.getItem(storageKey);
  const userSessionId = document.getElementById('user_session_id').value;
  if (cachedResponse) {
    return JSON.parse(cachedResponse);
  }
  try {
    const benAdminUrl = document.getElementById('benadmin_api_url').value;
    const docSummarizerUrl = `${benAdminUrl}/v1/self_service/chat_bot/summarize`;
    const response = await fetch(docSummarizerUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Cookie: `_session_id=${userSessionId}`,
      },
      body: JSON.stringify(requestData),
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    data.data &&
      data.data.description &&
      localStorage.setItem(storageKey, JSON.stringify(data.data));
    return data;
  } catch (error) {
    throw error;
  }
}

const handleFileNotFoundClick = async (event) => {
  const userSessionId = document.getElementById('user_session_id').value;
  const descriptionLoader =
    '<div class="description-loader"><svg id="dots" width="50px" height="21px" viewBox="0 0 132 58" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" fill="none"><g id="chatbot-loader" fill="#fff"><circle id="chatbot-loader-dot1" cx="25" cy="30" r="13"></circle><circle id="chatbot-loader-dot2" cx="65" cy="30" r="13"></circle><circle id="chatbot-loader-dot3" cx="105" cy="30" r="13"></circle></g></g></svg></div>';
  if (event.target.classList.contains('file-not-found')) {
    event.preventDefault();

    const newFileDescription = document.createElement('div');
    newFileDescription.setAttribute('class', 'file-description');
    newFileDescription.style.fontSize = `${originalFontSize}px`;
    newFileDescription.innerHTML = descriptionLoader;
    event.target.closest('.document-file').appendChild(newFileDescription);
    event.target.setAttribute('style', 'display: none');

    const fileUrl = event.target.getAttribute('data-file-url');
    const requestBody = {
      file_url: fileUrl,
      session_id: userSessionId === 'null' ? null : userSessionId,
    };
    fetchAndCacheSummary(requestBody)
      .then((response) => {
        response.data && response.data.description
          ? (newFileDescription.innerHTML = response.data.description)
          : (newFileDescription.innerHTML = 'No description available');
        event.target.remove();
      })
      .catch(() => {
        newFileDescription.innerHTML = 'Error fetching description';
      });
  }
};

const generateDescription = () => {
  const fileNotFound = document.querySelectorAll('.file-not-found');
  fileNotFound.forEach((file) => {
    file.addEventListener('click', (event) => handleFileNotFoundClick(event));
  });
};

const handleDocumentReaderUI = (data) => {
  const chatBotModal = document.querySelector('.chat-bot-modal');
  setTimeout(() => {
    const sliderUI = document.createElement('div');
    sliderUI.setAttribute('class', 'slider-ui-modal');
    sliderUI.innerHTML = `
        <div class="back-to-chat my-3"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#55575E" /></svg><span class="px-3 document-file-action" style="font-size:${originalFontSize}px" >Back To Chat</span></div>
        <div class="semi-bold mt-2 document-file-action" style="font-size:${originalFontSize}px" >Choose a file</div>
        <input type="text" id="document-search" class="search-document-file my-3" placeholder="Search document">
        <div class="document-file-list">...</div>
    `;
    if (chatBotModal) {
      chatBotModal.appendChild(sliderUI);
      chatBotModal.classList.add('grayed-out');
      chatBotModal.style.backgroundColor = '#55575e';
    }
    handleBackToChatClick();
    // eslint-disable-next-line import/no-default-export
    const renderDocumentList = (filterRegex = null) => {
      const fileListContainer = sliderUI.querySelector('.document-file-list');
      let filteredFiles = data[1].buttons;

      if (filterRegex) {
        filteredFiles = data[1].buttons.filter((file) =>
          filterRegex.test(file.title)
        );
      }

      fileListContainer.innerHTML = `<ul>${filteredFiles &&
        filteredFiles
          .map(
            (file) =>
              `<li class="document-file my-2 p-3 document-file-content">
            <div class="file-title" style="font-size:${originalFontSize}px">${file.title}</div>
            ${file.description
                ? `<div class="file-description" style="font-size:${originalFontSize}px" >${file.description}</div>`
                : `<a class="file-not-found" id="${file.title}" data-file-url="${file.file_url}" style="font-size:${originalFontSize}px">Get A Short Description</a>`
              }
          </li>`
          )
          .join('')
        }</ul>`;
      generateDescription();
      handleDocumentFileClick();
    };
    renderDocumentList();
    const searchInput = sliderUI.querySelector('#document-search');
    searchInput.addEventListener('input', () => {
      const searchInputValue = new RegExp(searchInput.value, 'i');
      renderDocumentList(searchInputValue);
    });
  }, 3000);
};

function handleBackToChatClick() {
  const backToChat = document.querySelector('.back-to-chat');
  backToChat.addEventListener('click', () => {
    closeSliderUI(true);
  });
}
function handleDocumentFileClick() {
  const documentFiles = document.querySelectorAll('.document-file');
  documentFiles.forEach((file) => {
    const titleElement = file.querySelector('.file-title');
    if (file.querySelector('.file-description')) {
      file.addEventListener('click', () => {
        createClientMessage(titleElement.textContent, true);
        closeSliderUI(false);
      });
    } else {
      titleElement.addEventListener('click', () => {
        createClientMessage(titleElement.textContent, true);
        closeSliderUI(false);
      });
    }
  });
}

function closeSliderUI(triggerBackToChatMessage = false) {
  const chatBotModal = document.querySelector('.chat-bot-modal');
  if (chatBotModal) {
    chatBotModal.classList.remove('grayed-out');
    chatBotModal.style.backgroundColor = 'white';
  }
  const sliderUI = document.querySelector('.slider-ui-modal');
  if (sliderUI) {
    sliderUI.remove();
  }
  triggerBackToChatMessage && createBotMessage('back_to_chat', true);
}
let serverTimeout;

const deleteChatHistory = ()=> {
  sessionStorage.removeItem(SESSION_STORAGE_CHAT_HISTORY_KEY);
};

// eslint-disable-next-line import/no-default-export
